module.exports = __webpack_public_path__ + "static/img/iphone_msp3.cf0266c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msp3.png
// module id = oR2f
// module chunks = 0